import { render } from "./ShopStatement.vue?vue&type=template&id=3ab10ed0&scoped=true"
import script from "./ShopStatement.vue?vue&type=script&lang=js"
export * from "./ShopStatement.vue?vue&type=script&lang=js"

import "./ShopStatement.vue?vue&type=style&index=0&id=3ab10ed0&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab10ed0"]])

export default __exports__